import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Hourglass High Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M195.545 2.56H60.455c-10.658 0-19.298 8.64-19.298 19.299V65.28a19.38 19.38 0 0 0 7.72 15.439L111.921 128l-63.046 47.281a19.38 19.38 0 0 0-7.72 15.439v43.422c0 10.657 8.642 19.298 19.3 19.298h135.089c10.658 0 19.298-8.64 19.298-19.298v-42.988a19.4 19.4 0 0 0-7.659-15.402L144.006 128l63.178-47.764a19.36 19.36 0 0 0 7.66-15.39V21.858c0-10.658-8.64-19.298-19.3-19.298m0 19.299v19.298H60.455V21.859Zm0 212.282H60.455V190.72L128 140.062l67.545 51.08ZM128 115.94 60.455 65.28v-4.825h135.09v4.39Z" }, null, -1)
  ]))]))
}
export default { render: render }